let accountContext = 'guest';
let accountRevision = 0;
export function setAccountContext(id: string | null) {
  const next = id ?? 'guest';
  if (next !== accountContext) accountRevision++;
  accountContext = next;
}
export function getAccountRevision() {
  return accountRevision;
}
export function accountHeaders() {
  return { 'X-Mujian-Account': accountContext };
}
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string,
  ) {
    super(message);
  }
}
export function assertAccountRevision(expected: number) {
  if (expected !== accountRevision)
    throw new ApiError('账号已切换，本次操作已取消。', 409, 'STALE_RESPONSE');
}
export async function throwResponseError(
  response: Response,
  expectedRevision?: number,
): Promise<never> {
  const data = await response.json().catch(() => ({ error: '请求未能完成，请稍后重试。' }));
  if (expectedRevision !== undefined) assertAccountRevision(expectedRevision);
  if (['AUTH_REQUIRED', 'ACCOUNT_CHANGED', 'ALREADY_AUTHENTICATED'].includes(data.code)) {
    window.dispatchEvent(new Event('mujian:account-invalid'));
  }
  throw new ApiError(data.error || '请求未能完成，请稍后重试。', response.status, data.code);
}
export async function api<T>(url: string, options?: RequestInit): Promise<T> {
  const guarded = url !== '/api/catalog' && url !== '/api/auth/session';
  const revision = accountRevision;
  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(guarded ? accountHeaders() : {}),
      ...options?.headers,
    },
  });
  if (!response.ok) return throwResponseError(response, guarded ? revision : undefined);
  const data = await response.json();
  if (guarded) assertAccountRevision(revision);
  return data;
}
